module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contact-tasks"
    }
  }, [_c('task-list', {
    ref: "task_list",
    attrs: {
      "filters": _vm.filters,
      "item_options": _vm.task_item_options,
      "sort": _vm.taskSort,
      "origem": "Base de contatos",
      "prop_tooltip_placement": _vm.prop_tooltip_placement
    },
    on: {
      "open-template-modal": _vm.bubbleUp,
      "toggle-task-bar": _vm.bubbleUp
    }
  }), _c('task-modal-form', {
    attrs: {
      "contact": _vm.contact
    },
    on: {
      "destroyed": _vm.removeTask
    }
  }), (_vm.show_meeting_modal) ? _c('meeting-modal', {
    staticStyle: {
      "top": "-10%",
      "left": "-10%"
    },
    attrs: {
      "task": _vm.selected_task
    },
    on: {
      "close-meeting-modal": function($event) {
        return _vm.closeMeetingModal()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a268344!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/tasks.vue
// module id = 1027
// module chunks = 1